import { MatchExpectation } from '@liquitics/matching';
import { Transaction } from '@liquitics/transaction';
import * as moment from 'moment';

export type AlertRowType = 'TIME_CRITICAL_PAYMENT' | 'MISSING_PAYMENT' | 'INSUFFICIENT_FUNDS';

export interface AlertRow {
    icon: string;
    type: AlertRowType;
    typeDisplay: string;
    transaction: Transaction;
    matchExpectation: MatchExpectation;
    expectedTimeMoment: moment.Moment;
    scaledAmount: string;
    minutesLate: number;
    description: string;
}

export function toAlertType(row: AlertRow): AlertRowType {

    if (row.matchExpectation.type === 'release') {
        return 'TIME_CRITICAL_PAYMENT';
    } else if (row.matchExpectation.type === 'confirmation') {
        return 'MISSING_PAYMENT';
    }
}
